import "./connectionLost.css";
import {t, TKeys} from "../../translationService";

export const showConnectionLostModal = () => document.getElementById("connectionLostModal").style.display = "flex";
export const hideConnectionLostModal = () => document.getElementById("connectionLostModal").style.display = "none";

export const ConnectionLostModal = () => {
    return <div id={"connectionLostModal"}>
        <div className={"content"}>
            <img src={"./assets/singleIcons/wifi.svg"}/>
            <div className={"text"}>
                {t(TKeys.CONNECTION_LOST)}...
            </div>
        </div>
    </div>
}
